import actions from './actions'
import getters from './getters'
import * as types from './types'

const state = {
  payables: [],
  pagination: {
    limit: 20,
    offset: 0,
    sortDesc: [true],
    sortBy: ['client_country']
  },
  totalItems: 0,
  isLoading: false,
  filters: {
    clientCountry: '',
    clientName: '',
    partnerId: '',
    amountFrom: null,
    amountTo: null,
    createdAtFrom: '',
    createdAtTo: '',
    state: []
  },
  payableDetails: {},
  requestInvoices: {
    value: false,
    url: null,
    number: ''
  }
}

const mutations = {
  [types.SET_PAYABLES](state, value) {
    state.payables = value
  },
  [types.SET_PAGINATION](state, value) {
    state.pagination = value
  },
  [types.SET_TOTAL_ITEMS](state, value) {
    state.totalItems = value
  },
  [types.SET_IS_LOADING](state, value) {
    state.isLoading = value
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_PAYABLE_DETAILS](state, value) {
    state.payableDetails = value
  },
  [types.SET_INVOICE_INFO](state, value) {
    state.requestInvoices = value
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
